import request from '@/utils/request'

/**
 * 搜索页平台+活动
 * https://www.showdoc.com.cn/1003739271891029/10377920895866574
 */
export function fetchTypes(params) {
    return request({
        url: '/api/selection_library/search_goods/cate',
        params: params,
        method: 'get'
    })
}

/**
 * 搜索页分类筛选
 * https://www.showdoc.com.cn/1003739271891029/10377922331776627
 */
export function fetchCates(data) {
    return request({
        url: '/api/selection_library/search_goods/screen',
        data,
        method: 'post'
    })
}

/**
 * 搜索页商品列表
 * https://www.showdoc.com.cn/1003739271891029/10377937556048301
 */
export function searchGoods(data) {
    return request({
        url: '/api/selection_library/search_goods/list',
        data,
        method: 'post'
    })
}
